import { createAction } from '@reduxjs/toolkit'

export const setQueryList = createAction<{ list: any }>('http/queryList')
export const setEthPrice = createAction<{ price: any }>('http/ethPrice')
export const setRoxPrice = createAction<{ price: any }>('http/roxPrice')
export const setVoteCurrentId = createAction<{ id: number }>('http/voteCurrentId')
export const setLeaderboardCurrentId = createAction<{ id: number }>('http/LeaderboardCurrentId')
export const setLeaderboardinnerCurrentId = createAction<{ id: number }>('http/LeaderboardinnerCurrentId')
